import type {ReactElement} from 'react';
import {ColorControl} from '@FormMakerReact/layout/form-maker-right-panel/controls/color-control/color-control';
import {DEFAULT_BG_COLOR} from '@FormMakerReact/layout/form-maker-right-panel/sectors/form-background-sector/form-background-sector.types';
import type {FormBackgroundBgColorControlProps} from './form-background-bg-color-control.types';

export function FormBackgroundBgColorControl({component}: FormBackgroundBgColorControlProps): ReactElement {
  return (
    <ColorControl
      component={component}
      property="background-color"
      labelKey="pmwjs_form_maker_control_bg_color_label"
      pickAriaKey="pmwjs_form_maker_control_bg_color_pick"
      clearAriaKey="pmwjs_form_maker_control_bg_color_clear"
      defaultColor={DEFAULT_BG_COLOR}
      hideClearButton
    />
  );
}
